/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PatchOperatingCostInvoiceV1Dto = {
  /**
   * The current version of the contract.
   */
  version: number;
  /**
   * Contract ID linked to this operating cost invoice (UUID v4, 8-4-4-4-12).
   */
  contractId?: string;
  /**
   * PointOfSale ID linked to this operating cost invoice (UUID v4, 8-4-4-4-12).
   */
  pointOfSaleId?: string;
  /**
   * Legal/trade name of the company that issued the invoice (snapshot, denormalized).
   */
  issuerLegalName?: string;
  /**
   * Invoice issue date (calendar date the invoice was created/issued).
   */
  issueDate?: string;
  /**
   * Start of the billing period covered by this operating cost invoice.
   */
  periodStart?: string;
  /**
   * End of the billing period covered by this operating cost invoice.
   */
  periodEnd?: string;
  /**
   * Deadline for the tenant to request inspection of supporting documents.
   */
  documentReviewDeadline?: string;
  /**
   * Formal objection deadline for disputing this invoice.
   */
  objectionDeadline?: string;
  /**
   * Internal objection handling deadline (for back-office workflows).
   */
  internalObjectionDeadline?: string;
  /**
   * Customer prepayment (net) actually received for this period.
   */
  customerPrepaymentNet?: number;
  /**
   * Customer prepayment (gross, incl. VAT) for this period.
   */
  customerPrepaymentGross?: number;
  /**
   * Prepayment (net) as claimed/declared by the customer (may differ from actual receipts).
   */
  statedCustomerPrepaymentNet?: number;
  /**
   * Settlement result (net, before VAT). Positive = surcharge; negative = credit.
   */
  settlementResultNet?: number;
  /**
   * Settlement result (gross, incl. VAT). Positive = surcharge; negative = credit.
   */
  settlementResultGross?: number;
  /**
   * Total operating costs for the period (net, before VAT).
   */
  costsNet?: number;
  /**
   * VAT rate in percent (e.g., 19.00). Up to 2 decimal places.
   */
  vatRate?: number;
  /**
   * Indicates whether heating costs are settled in compliance with HKVO (Heizkostenverordnung).
   */
  isHeatingCostsCompliantHKVO?: boolean;
  /**
   * Ticket ID linked to this operating cost invoice (UUID v4, 8-4-4-4-12).
   */
  ticketId?: string;
  /**
   * The currency of the payment.
   */
  currency: PatchOperatingCostInvoiceV1Dto.currency;
};
export namespace PatchOperatingCostInvoiceV1Dto {
  /**
   * The currency of the payment.
   */
  export enum currency {
    EUR = 'EUR',
    ALL = 'ALL',
    AMD = 'AMD',
    AZN = 'AZN',
    BYN = 'BYN',
    BAM = 'BAM',
    CZK = 'CZK',
    DKK = 'DKK',
    GEL = 'GEL',
    GIP = 'GIP',
    GGP = 'GGP',
    HUF = 'HUF',
    ISK = 'ISK',
    IMP = 'IMP',
    JEP = 'JEP',
    KZT = 'KZT',
    CHF = 'CHF',
    MDL = 'MDL',
    MKD = 'MKD',
    NOK = 'NOK',
    PLN = 'PLN',
    RON = 'RON',
    RUB = 'RUB',
    RSD = 'RSD',
    SEK = 'SEK',
    TRY = 'TRY',
    UAH = 'UAH',
    GBP = 'GBP',
  }
}
